'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.debug = exports.error = undefined;

var _environment = require('../lib/environment');

var _environment2 = _interopRequireDefault(_environment);

var _envs = require('../configs/envs');

var envs = _interopRequireWildcard(_envs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @since 2017-06-19 16:03:13
 * @author vivaxy
 */

var error = exports.error = function error() {
    var _console;

    for (var _len = arguments.length, data = Array(_len), _key = 0; _key < _len; _key++) {
        data[_key] = arguments[_key];
    }

    (_console = console).error.apply(_console, ['[CMP]'].concat(data));
};

var debug = exports.debug = function debug() {
    for (var _len2 = arguments.length, data = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        data[_key2] = arguments[_key2];
    }

    if (_environment2.default !== envs.PRODUCTION) {
        var _console2;

        (_console2 = console).log.apply(_console2, ['[CMP]'].concat(data));
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/logger.js
// module id = 233
// module chunks = 0